import { PaymentSourceType } from "features/Payments/constants/payment.constants";
import * as Yup from "yup";

const schema = Yup.object({
  sourceType: Yup.mixed<PaymentSourceType>()
    .oneOf([
      PaymentSourceType.INVOICE,
      PaymentSourceType.CLIENT_ADVANCE,
      PaymentSourceType.EMPLOYEE_ADVANCE,
      PaymentSourceType.PAYROLL_ITEM,
    ])
    .required("Source type is required"),
  sourceId: Yup.number().required("The Source field is required"),
  amount: Yup.number()
    .min(1, "Amount must be greater than 0")
    .required("The amount field is required"),
  modeOfPaymentId: Yup.string().required(
    "The mode of payment field is required",
  ),
  paymentDate: Yup.string()
    .required("The payment date field is required")
    .test(
      "not-future",
      "Payment date cannot be a future date",
      (value) => {
        if (!value) return false;
        const selectedDate = new Date(value);
        const today = new Date();
        today.setHours(23, 59, 59, 999);
        return selectedDate <= today;
      },
    ),
  referenceNumber: Yup.string(),
  remarks: Yup.string().nullable(),
});

export default schema;
